import qs from 'qs';

export default function useUrlParams(): any {
  return qs.parse(window.location.search, { ignoreQueryPrefix: true });
}
